import { render } from "./WorkDetails.vue?vue&type=template&id=12311674&scoped=true"
import script from "./WorkDetails.vue?vue&type=script&lang=js"
export * from "./WorkDetails.vue?vue&type=script&lang=js"

import "./WorkDetails.vue?vue&type=style&index=0&id=12311674&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-12311674"

export default script